import React, { useRef } from 'react';
import helpers from "../_helpers/helpersFunction";

export default function ThumbnailGallery({ thumbnails, onSelect }) {
    const { collection_folder, default_folder } = helpers.getCDNfolder();
    const galleryRef = useRef(null);

    const scrollLeft = () => {
        galleryRef.current.scrollBy({ left: -100, behavior: 'smooth' });
    };

    const scrollRight = () => {
        galleryRef.current.scrollBy({ left: 100, behavior: 'smooth' });
    };

    const handleDragStart = (e) => {
        galleryRef.current.isDragging = true;
        galleryRef.current.startX = e.pageX - galleryRef.current.offsetLeft;
        galleryRef.current.scrollLeft = galleryRef.current.scrollLeft;
    };

    const handleDragEnd = () => {
        galleryRef.current.isDragging = false;
    };

    const handleDragMove = (e) => {
        if (!galleryRef.current.isDragging) return;
        e.preventDefault();
        const x = e.pageX - galleryRef.current.offsetLeft;
        const walk = (x - galleryRef.current.startX) * 2; // Velocità di scorrimento
        galleryRef.current.scrollLeft = galleryRef.current.scrollLeft - walk;
    };

    const handleThumbnailClick = (e, src) => {
        e.preventDefault(); // Previene l'azione di default del browser
        onSelect(src);
    };

    return (
        <>
            {thumbnails ? (
                <div className="thumbnail-gallery-container">
                    <button className="scroll-button left" onClick={scrollLeft}>&lt;</button>
                    <div
                        className="thumbnail-gallery"
                        ref={galleryRef}
                        onMouseDown={handleDragStart}
                        onMouseLeave={handleDragEnd}
                        onMouseUp={handleDragEnd}
                        onMouseMove={handleDragMove}
                    >
                        {thumbnails.map((thumbnail, index) => (
                            <img
                                key={index}
                                src={process.env.REACT_APP_CDN + "/" + collection_folder + "/" + thumbnail.id}
                                className="thumbnail"
                                onClick={(e) => handleThumbnailClick(e,process.env.REACT_APP_CDN + "/" + collection_folder + "/" + thumbnail.default)}
                            />
                        ))}
                    </div>
                    <button className="scroll-button right" onClick={scrollRight}>&gt;</button>
                </div>
            ) : <></>}
        </>
    );
}